module.exports = __webpack_public_path__ + "img/clock-rewind.6ba7328f.svg";